module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#crime",
      toString: function () {
        return this.url;
      }
    }